export default {
    loadData : async function() {
        let listData = require('../assets/weapons/datas/heroAndWeaponDatas.json')
        return listData;
    }
}